import React from 'react';
import {
    ServicesPerMonthPerYearPercentage,
    ServicesPerMonthPerYearTotal,
    ServicesPerYearPercentage,
    ServicesPerYearTotal
} from '../../../../Common/Services/charts/apex-charts';
import { useServicesChartsDataContext } from '../../../../Common/Services/hooks/useServicesChartsDataContext';
import Loading from '../../../../Common/Loading';

const Services = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <ServicesPerYearPercentage />
                <ServicesPerMonthPerYearPercentage />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ServicesPerYearTotal />
                <ServicesPerMonthPerYearTotal />
            </div>
        </>
    );
};

export default Services;
